import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.number.constructor.js";
import { __decorate } from "tslib";
import { bananDetail, insteadTroduce, insteadTroduceCustomized, getProductInfo } from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // 展示图片
    _this.bannerList = [];
    // 0代打印，1耗材定制
    _this.type = Number(_this.$route.query.type);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getBannerDetails();
    }
  }, {
    key: "getBannerDetails",
    value: function () {
      var _getBannerDetails = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$$route$query, id, type, from, res, anchor, _res, _res2, _res3;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$$route$query = this.$route.query, id = _this$$route$query.id, type = _this$$route$query.type, from = _this$$route$query.from;
              if (!(from === 'carousel')) {
                _context.next = 8;
                break;
              }
              _context.next = 4;
              return bananDetail({
                id: id,
                channel: 1,
                type: type
              });
            case 4:
              res = _context.sent;
              this.bannerList = res.data.data.detail;
              _context.next = 27;
              break;
            case 8:
              if (!(from === 'details')) {
                _context.next = 16;
                break;
              }
              anchor = readCookie('anchor');
              _context.next = 12;
              return getProductInfo({
                productId: this.$route.query.id,
                model: anchor ? anchor.model : '',
                equipMeid: anchor ? anchor.equipMeid : '',
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                companyId: 1
              });
            case 12:
              _res = _context.sent;
              this.bannerList = _res.data.data.product.descPics;
              _context.next = 27;
              break;
            case 16:
              if (!(this.type === 0)) {
                _context.next = 23;
                break;
              }
              _context.next = 19;
              return insteadTroduce({
                id: id
              });
            case 19:
              _res2 = _context.sent;
              this.bannerList = _res2.data.data.detail;
              _context.next = 27;
              break;
            case 23:
              _context.next = 25;
              return insteadTroduceCustomized({
                id: id
              });
            case 25:
              _res3 = _context.sent;
              this.bannerList = _res3.data.data.detail;
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getBannerDetails() {
        return _getBannerDetails.apply(this, arguments);
      }
      return getBannerDetails;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    BackTop: BackTop
  }
})], default_1);
export default default_1;